'use client';

import classNames from 'classnames';
import { FC, PropsWithChildren, ReactNode, createContext, useContext, useState } from 'react';
type ScorecardCourseLegendContextType = {
  roundId: string;
  selectedCourseLabel?: string;
  setSelectedCourseLabel: (value?: string) => void;
};
const ScorecardCourseLegendContext = createContext<ScorecardCourseLegendContextType>({} as ScorecardCourseLegendContextType);
export const ScorecardCourseLegend: FC<{
  childrenByCourseLabel: Record<string, ReactNode>;
}> = ({
  childrenByCourseLabel
}) => {
  const {
    selectedCourseLabel,
    roundId
  } = useScorecardCourseLegendContext();
  return <div className="divide-y divide-gray-200" data-sentry-component="ScorecardCourseLegend" data-sentry-source-file="scorecard-course-legend.tsx">
      {Object.entries(childrenByCourseLabel).map(([courseLabel, child]) => courseLabel.includes(roundId) ? <div key={courseLabel} className={classNames('transition-opacity duration-300 leading-7 mb-1', {
      'opacity-20': selectedCourseLabel && !courseLabel.includes(selectedCourseLabel)
    })}>
            {child}
          </div> : null)}
    </div>;
};
export const ScorecardCourseLegendProvider: FC<PropsWithChildren<Pick<ScorecardCourseLegendContextType, 'roundId'>>> = ({
  children,
  ...props
}) => {
  const [selectedCourseLabel, setSelectedCourseLabel] = useState<string | undefined>();
  return <ScorecardCourseLegendContext.Provider value={{
    selectedCourseLabel,
    setSelectedCourseLabel,
    ...props
  }} data-sentry-element="unknown" data-sentry-component="ScorecardCourseLegendProvider" data-sentry-source-file="scorecard-course-legend.tsx">
      {children}
    </ScorecardCourseLegendContext.Provider>;
};
export const useScorecardCourseLegendContext = () => useContext(ScorecardCourseLegendContext);